import { useCallback, useMemo, useState } from "react";
import { Modal } from "@/shared/ui";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";
import PlayerMenuSettingsSafetyConfirmChangingEmailContainer from "@/domains/playerMenu/containers/settings/safety/change-email/PlayerMenuSettingsSafetyConfirmChangingEmailContainer";
import PlayerMenuSettingsSafetyConfirmNewEmailContainer from "@/domains/playerMenu/containers/settings/safety/change-email/PlayerMenuSettingsSafetyConfirmNewEmailContainer";
import PlayerMenuSettingsSafetyEnterCurrEmailContainer from "@/domains/playerMenu/containers/settings/safety/change-email/PlayerMenuSettingsSafetyEnterCurrEmailContainer";

const MEX_STEP = 3;

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyChangeEmailContainer({ onClose }: Props) {
  const { getGameSettings } = useGameSettings();
  const [step, setStep] = useState(1);
  const [currEmail, setCurrEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");

  const next = useCallback(() => {
    setStep((state) => (state === MEX_STEP ? state : state + 1));
  }, []);

  const onConfirm = useCallback(() => {
    onClose();
    getGameSettings();
  }, [onClose, getGameSettings]);

  const title = useMemo(
    () => ({
      "1": "Смена Email адреса",
      "2": "Подтверждение смены Email",
      "3": "Подтверждение нового Email адреса",
    }),
    [],
  );

  return (
    <Modal open onClose={onClose} title={title[step]} className="h-[49rem]">
      {step === 1 && (
        <PlayerMenuSettingsSafetyEnterCurrEmailContainer
          onCancel={onClose}
          next={next}
          onChangeCurrEmail={setCurrEmail}
        />
      )}
      {step === 2 && (
        <PlayerMenuSettingsSafetyConfirmChangingEmailContainer
          currEmail={currEmail}
          next={next}
          onChangeNewEmail={setNewEmail}
        />
      )}
      {step === 3 && (
        <PlayerMenuSettingsSafetyConfirmNewEmailContainer
          newEmail={newEmail}
          onConfirm={onConfirm}
        />
      )}
    </Modal>
  );
}
